module.exports = __webpack_public_path__ + "62d0d8fc.png";